// components/TenantLanding/Login/RegisterForms/Identity1.js
import React from "react";

const NAME_ORDER_OPTIONS = [
  { value: "Given-Family", label: "Given–Family" },
  { value: "Family-Given", label: "Family–Given" },
  { value: "Single", label: "Single name" },
];

const Identity1 = ({ formData, errors, loading, handleChange, handleNext, handlePrevious }) => {
  return (
    <div className="register-stage1-section">
      <h3 className="register-stage1-section__title">
        <span className="register-stage1-section__icon">👤</span>
        Identity
      </h3>
      <p className="register-stage1-section__subtitle">
        Candidate identity information.
      </p>

      <div className="register-stage1-form__row">
        <div className="register-stage1-form__col-third">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              First Name <span className="register-stage1-form__required">*</span>
            </label>
            <input
              type="text"
              name="first_name"
              className={`register-stage1-form__input ${errors.first_name ? "register-stage1-form__input--error" : ""}`}
              value={formData.first_name}
              onChange={handleChange}
              placeholder="Manoj"
              disabled={loading}
            />
            {errors.first_name && (
              <span className="register-stage1-form__error-text">{errors.first_name}</span>
            )}
          </div>
        </div>

        <div className="register-stage1-form__col-third">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">Middle Name</label>
            <input
              type="text"
              name="middle_name"
              className="register-stage1-form__input"
              value={formData.middle_name}
              onChange={handleChange}
              placeholder="Middle name (optional)"
              disabled={loading}
            />
            <small className="register-stage1-form__help-text">
              Leave blank if not applicable.
            </small>
          </div>
        </div>

        <div className="register-stage1-form__col-third">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">Last Name / Family Name</label>
            <input
              type="text"
              name="last_name"
              className="register-stage1-form__input"
              value={formData.last_name}
              onChange={handleChange}
              placeholder="Soneji"
              disabled={loading}
            />
            <small className="register-stage1-form__help-text">
              Leave blank if you have a single name.
            </small>
          </div>
        </div>

        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">Preferred Professional Name</label>
            <input
              type="text"
              name="preferred_name"
              className="register-stage1-form__input"
              value={formData.preferred_name}
              onChange={handleChange}
              placeholder="Name shown in profile and CV"
              disabled={loading}
            />
            <small className="register-stage1-form__help-text">
              Will fallback to your legal/display name if not set.
            </small>
          </div>
        </div>

        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              Name Display Order <span className="register-stage1-form__required">*</span>
            </label>
            <select
              name="name_display_order"
              className={`register-stage1-form__select ${errors.name_display_order ? "register-stage1-form__select--error" : ""}`}
              value={formData.name_display_order}
              onChange={handleChange}
              disabled={loading}
            >
              {NAME_ORDER_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.name_display_order && (
              <span className="register-stage1-form__error-text">{errors.name_display_order}</span>
            )}
            <small className="register-stage1-form__help-text">
              Prevents incorrect formatting for different nationalities.
            </small>
          </div>
        </div>
      </div>

      <div className="register-stage1-form__actions">
        <button
          type="button"
          className="register-stage1-form__btn register-stage1-form__btn--outline"
          onClick={handlePrevious}
          disabled={loading}
        >
          ← Back
        </button>
        <button
          type="button"
          className="register-stage1-form__btn register-stage1-form__btn--primary"
          onClick={handleNext}
          disabled={loading}
        >
          Continue →
        </button>
      </div>
    </div>
  );
};

export default Identity1;